var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: {
        id: "tester-eligibilite",
        name: "tester-eligibilite",
        method: "post",
        action: _vm.initEligibilityUrl,
      },
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "token" },
        domProps: { value: _vm.token },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "offreInternet" },
        domProps: { value: _vm.highlightedInternetOfferSeoId },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "offreMobile" },
        domProps: { value: _vm.highlightedMobileOfferSeoId },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }